import { BuildDurationData } from 'src/components/pipelines/hooks/use-build-duration';
import { formatDuration } from 'src/components/pipelines/hooks/use-pipelines-timeseries';
import { useIntl } from 'src/hooks/intl';

import { messages } from '../metric-cards/i18n';

import { AverageChart } from './average-chart';
import { averageColorAccessor, declineValueComparator } from './utils';

export const AverageBuildDuration = (props: BuildDurationData) => {
  const { formatMessage } = useIntl();

  return (
    <AverageChart
      {...props}
      chartConfig={[
        {
          dataKey: 'duration',
          colorAccessor: averageColorAccessor,
        },
      ]}
      tooltipConfig={[
        {
          dataAccessor: data => formatDuration(data?.duration),
          label: formatMessage(messages.duration),
        },
        {
          dataAccessor: data => data?.recordCount?.toLocaleString(),
          label: formatMessage(messages.count),
        },
      ]}
      chartValueComparator={declineValueComparator}
      dataFormatter={formatDuration}
      chartTitle={formatMessage(messages.buildDurationTitle)}
    />
  );
};
